var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2088 3.5415H4.79211C3.4114 3.5415 2.29211 4.66079 2.29211 6.0415V13.9582C2.29211 15.3389 3.4114 16.4582 4.79211 16.4582H15.2088C16.5895 16.4582 17.7088 15.3389 17.7088 13.9582V6.0415C17.7088 4.66079 16.5895 3.5415 15.2088 3.5415Z",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29211 6.6665L9.30462 9.88817C9.52288 9.98846 9.76025 10.0404 10.0004 10.0404C10.2407 10.0404 10.478 9.98846 10.6963 9.88817L17.7088 6.6665",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ad15fc99759a8e16908440e84f49ed7c.svg";
export { ForwardRef as ReactComponent };